import cn from 'classnames';
import styles from './Shadow.module.scss';

type ShadowProps = {
  className?: string;
  dark?: boolean;
  opacity?: number;
};

export function Shadow({ className, dark, opacity }: ShadowProps) {
  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.dark]: dark,
    },
    className,
  );

  if (opacity) {
    return (
      <div
        className={wrapperClassName}
        style={{ background: `rgba(0, 0, 0, ${opacity})` }}
      />
    );
  }

  return <div className={wrapperClassName} />;
}
